export default __webpack_public_path__ + "static/nodejs-development-company-peerbits-200e8ce29d0792237bcf1a9f78dd26ed.png";